const newWorkspace = {
  bindings: {
    workspace: '<',
    mode: '<',
    onSubmit: '&',
    onCancel: '&'
  },
  templateUrl:
    '/modules/pis-tool/workspaces/workspace-modal/new-workspace/new-workspace.html',
  controller: 'NewWorkspaceController',
};

angular
  .module('pis-tool.module')
  .component('newWorkspace', newWorkspace);
